const googleCalendarPermissions = "https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events";
const microsoftCalendarPermissions = "Calendars.ReadWrite MailboxSettings.Read";

module.exports = {
	googleApiKey: "AIzaSyD1rQoOBzqWZJ4XDZ8j-rUkiqC6EyDWnK8",
	googleClientId: "123884196112-uhda9nva9ofvnuiv38n469c4o2258j02.apps.googleusercontent.com",
	googleCalendarPermissions,
	microsoftCalendarPermissions,
	baseAppUri: "https://app.teaming.com",
	baseUri: "https://api.teaming.com/api",
	UserPoolId: "us-east-1_kY1jT15di",
	UserPoolAppClientId: "4o279gih4et8fdsp4010kldd9k",
	AmplitudeToken: "15ecada3bef092a9a0d2d49e4dcd34bd",
	IntercomAppId: "r8ndhhg6",
	enableLegacyIntercom: true,
	MeetingCenterWS: "wss://ws.teaming.com",
	rollbarToken: "d34f04241b07447cb0e81d5688cceb43",
	rollbarEnv: "rollbar_production",
	auth0Audience: "https://meetingful.auth0.com/api/v2/",
	auth0Domain: "auth.teaming.com",
	auth0ClientId: "5ygKPeQEiekcvalZWWGQmee0wXGppyP6",
	meetingCenterIntercomTourId: "119900",
	apiSocketEndpoint: "wss://socks.teaming.com",
	enableMarkdownEditors: true,
	enable1on1TeamView: true,
	enableTeamOverview: true,
	enabled1on1Tabs: [
		"GOALS",
	],
	permitMobileMenu: true,
	showStripeIntegration: false,
	stripePaymentLink: "https://buy.stripe.com/9AQ8yb0xiguJaQgdR3",
};



//////////////////
// WEBPACK FOOTER
// ./config/env-vars-prod.js
// module id = t7nL
// module chunks = 5